var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-on-focus-case"},[_c('div',{staticClass:"icon-wrapper"},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['fas', 'lightbulb']}})],1),_c('div',[_vm._v(_vm._s(_vm.$t('knowledge.search-admin.restrict-focus-case')))]),_c('Tag',{staticClass:"ml-2",attrs:{"tag":_vm.tag},on:{"focus":_vm.handleSearchInFocusCase}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }